import React from 'react';
import { APrice } from '../../atoms/APrice/index';
import { APriceSize } from '../../atoms/APrice/APrice.types';
import { ACurrency } from '../../atoms/ACurrency/index';
import { ACurrencySize } from '../../atoms/ACurrency/ACurrency.types';
import Styled from './MRate.styles';
import type { MRateProps } from './MRate.types';

const COMPONENT_NAME = 'm-web-ui-kit-MRate';
const TEST_ID = 'web-ui-kit-MRate';

const getProportionateCurrencySize = (priceSize?: APriceSize): ACurrencySize => {
  return priceSize === APriceSize.Small ? ACurrencySize.ExtraSmall : ACurrencySize.Medium;
};

export const MRate: React.FC<MRateProps> = ({ aPrice, aCurrency, className, ...rest }) => {
  const proportionateCurrencySize = getProportionateCurrencySize(aPrice?.size);

  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} className={className} {...rest}>
      {aPrice && (
        <Styled.PriceWrapper>
          <APrice {...aPrice} />
        </Styled.PriceWrapper>
      )}
      {aCurrency && (
        <Styled.CurrencyWrapper>
          <ACurrency {...aCurrency} size={proportionateCurrencySize} />
        </Styled.CurrencyWrapper>
      )}
    </Styled.Wrapper>
  );
};

export { TEST_ID as M_RATE_TEST_ID };
